import { FC } from 'react';

import { context } from './context';
import { useStorePreviousPath } from './use-store-previous-path';

export const PreviousPathProvider: FC = ({ children }) => {
  const path = useStorePreviousPath();
  return <context.Provider value={path}>{children}</context.Provider>;
};
